module.exports = __webpack_public_path__ + "static/media/addOnIconDisabled.ba919311.svg";